(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aboreo-collection-grid"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   Catálogo Aboreo — buscador + filtros (panel lateral)
   El panel se construye leyendo los atributos data-* de las tarjetas, así que
   se adapta solo cuando entran productos o series nuevas. Búsqueda y filtros
   son un único motor para que no se peleen por mostrar/ocultar las tarjetas.
   ========================================================================== */
(function () {
  'use strict';

  function iniciar() {
    var sec = document.querySelector('[data-aboreo-catalog]');
    if (!sec) return;

    var grid = sec.querySelector('[data-aboreo-catalog-grid]');
    var panel = sec.querySelector('[data-filtros]');
    var cuerpo = sec.querySelector('[data-filtros-cuerpo]');
    if (!grid || !panel || !cuerpo) return;

    var tarjetas = [].slice.call(grid.querySelectorAll('.aboreo-card')).map(function (el) {
      return {
        el: el,
        titulo: (el.getAttribute('data-title') || ''),
        tags: (el.getAttribute('data-tags') || '').toLowerCase(),
        cols: (el.getAttribute('data-cols') || '').toLowerCase(),
        precio: parseInt(el.getAttribute('data-precio') || '0', 10),
        stock: el.getAttribute('data-stock') === '1',
        tipo: (el.getAttribute('data-tipo') || '').trim()
      };
    });
    if (!tarjetas.length) return;

    var tiene = function (c, tag) { return c.tags.indexOf('|' + tag.toLowerCase() + '|') !== -1; };
    var enCol = function (c, h) { return c.cols.indexOf('|' + h.toLowerCase() + '|') !== -1; };

    /* ---- series presentes, ordenadas por cantidad ---- */
    var mapa = (sec.getAttribute('data-series') || '').split('|');
    var series = [];
    mapa.forEach(function (par) {
      var corte = par.indexOf(':');
      if (corte < 1) return;
      var tag = par.slice(0, corte).trim();
      var nombre = par.slice(corte + 1).trim();
      var n = tarjetas.filter(function (c) { return enCol(c, tag); }).length;
      if (n > 0) series.push({ val: tag, lab: nombre, n: n });
    });
    series.sort(function (a, b) { return b.n - a.n || a.lab.localeCompare(b.lab); });

    /* ---- precios: solo los tramos que tienen algo ---- */
    var tramos = [
      { val: 'p1', lab: 'Menos de $50.000',    min: 0,      max: 49999 },
      { val: 'p2', lab: '$50.000 a $99.999',   min: 50000,  max: 99999 },
      { val: 'p3', lab: '$100.000 a $179.999', min: 100000, max: 179999 },
      { val: 'p4', lab: '$180.000 o más',      min: 180000, max: Infinity }
    ].filter(function (t) {
      return tarjetas.some(function (c) { return c.precio >= t.min && c.precio <= t.max; });
    });

    /* ---- tipos de producto presentes ---- */
    var tipos = [];
    tarjetas.forEach(function (c) {
      if (c.tipo && tipos.indexOf(c.tipo) === -1) tipos.push(c.tipo);
    });
    tipos.sort();

    /* ---- definición de los grupos ---- */
    var grupos = [];
    if (series.length > 1) {
      grupos.push({
        id: 'serie', titulo: 'Serie', verMas: 6,
        ops: series.map(function (s) {
          return { val: s.val, lab: s.lab, test: function (c) { return enCol(c, s.val); } };
        })
      });
    }
    if (tramos.length > 1) {
      grupos.push({
        id: 'precio', titulo: 'Precio',
        ops: tramos.map(function (t) {
          return { val: t.val, lab: t.lab, test: function (c) { return c.precio >= t.min && c.precio <= t.max; } };
        })
      });
    }
    var hayImportado = tarjetas.some(function (c) { return tiene(c, 'importado-eeuu'); });
    var hayNacional = tarjetas.some(function (c) { return !tiene(c, 'importado-eeuu'); });
    if (hayImportado && hayNacional) {
      grupos.push({
        id: 'entrega', titulo: 'Entrega',
        ops: [
          { val: 'nac', lab: 'Llega en 2-7 días', test: function (c) { return !tiene(c, 'importado-eeuu'); } },
          { val: 'imp', lab: 'Importado EE. UU.', test: function (c) { return tiene(c, 'importado-eeuu'); } }
        ]
      });
    }
    if (tipos.length > 1) {
      grupos.push({
        id: 'tipo', titulo: 'Tipo',
        ops: tipos.map(function (t) {
          return { val: t, lab: t, test: function (c) { return c.tipo === t; } };
        })
      });
    }
    if (tarjetas.some(function (c) { return !c.stock; })) {
      grupos.push({
        id: 'stock', titulo: 'Disponibilidad',
        ops: [{ val: '1', lab: 'Solo lo que hay en stock', test: function (c) { return c.stock; } }]
      });
    }
    if (!grupos.length) return;

    /* ---- estado ---- */
    var estado = {};
    grupos.forEach(function (g) { estado[g.id] = []; });
    var busqueda = '';
    var expandidos = {};

    function leerUrl() {
      var p = new URLSearchParams(location.search);
      grupos.forEach(function (g) {
        var v = p.get(g.id);
        if (!v) return;
        estado[g.id] = v.split(',').filter(function (x) {
          return g.ops.some(function (o) { return o.val === x; });
        });
      });
      var q = p.get('q');
      if (q) busqueda = q.toLowerCase();
    }

    function escribirUrl() {
      var p = new URLSearchParams(location.search);
      grupos.forEach(function (g) {
        if (estado[g.id].length) p.set(g.id, estado[g.id].join(','));
        else p.delete(g.id);
      });
      if (busqueda) p.set('q', busqueda); else p.delete('q');
      var q = p.toString();
      history.replaceState(null, '', location.pathname + (q ? '?' + q : ''));
    }

    /* ---- filtrado ---- */
    function pasaGrupo(c, g) {
      var sel = estado[g.id];
      if (!sel.length) return true;
      return g.ops.some(function (o) { return sel.indexOf(o.val) !== -1 && o.test(c); });
    }
    function pasaTodo(c, exceptoId) {
      if (busqueda && c.titulo.indexOf(busqueda) === -1) return false;
      return grupos.every(function (g) { return g.id === exceptoId || pasaGrupo(c, g); });
    }
    function activos() {
      return grupos.reduce(function (n, g) { return n + estado[g.id].length; }, 0);
    }

    /* ---- pintar el panel ---- */
    function pintarPanel() {
      cuerpo.innerHTML = '';
      grupos.forEach(function (g) {
        var caja = document.createElement('div');
        caja.className = 'aboreo-filtros__grupo';
        var h = document.createElement('p');
        h.className = 'aboreo-filtros__grupo-tit';
        h.textContent = g.titulo;
        caja.appendChild(h);

        var base = tarjetas.filter(function (c) { return pasaTodo(c, g.id); });
        var limite = (g.verMas && !expandidos[g.id]) ? g.verMas : g.ops.length;

        g.ops.slice(0, limite).forEach(function (o) {
          var n = base.filter(o.test).length;
          var marcado = estado[g.id].indexOf(o.val) !== -1;
          var l = document.createElement('label');
          l.className = 'aboreo-filtros__op' + (n === 0 && !marcado ? ' aboreo-filtros__op--cero' : '');
          var i = document.createElement('input');
          i.type = 'checkbox';
          i.checked = marcado;
          i.disabled = (n === 0 && !marcado);
          i.addEventListener('change', function () {
            var arr = estado[g.id];
            var pos = arr.indexOf(o.val);
            if (i.checked && pos === -1) arr.push(o.val);
            else if (!i.checked && pos !== -1) arr.splice(pos, 1);
            aplicar();
          });
          var t = document.createElement('span');
          t.textContent = o.lab;
          var c = document.createElement('span');
          c.className = 'aboreo-filtros__op-n';
          c.textContent = n;
          l.append(i, t, c);
          caja.appendChild(l);
        });

        if (g.verMas && g.ops.length > g.verMas) {
          var mas = document.createElement('button');
          mas.type = 'button';
          mas.className = 'aboreo-filtros__mas';
          mas.textContent = expandidos[g.id]
            ? 'Ver menos'
            : 'Ver las ' + g.ops.length + ' series';
          mas.addEventListener('click', function () {
            expandidos[g.id] = !expandidos[g.id];
            pintarPanel();
          });
          caja.appendChild(mas);
        }
        cuerpo.appendChild(caja);
      });

      if (activos()) {
        var limpiar = document.createElement('button');
        limpiar.type = 'button';
        limpiar.className = 'aboreo-filtros__limpiar';
        limpiar.textContent = 'Quitar todos los filtros';
        limpiar.addEventListener('click', limpiarTodo);
        cuerpo.appendChild(limpiar);
      }
    }

    function limpiarTodo() {
      grupos.forEach(function (g) { estado[g.id] = []; });
      aplicar();
    }

    /* ---- pintar chips de filtros puestos ---- */
    function pintarChips(visibles) {
      var zonaEstado = sec.querySelector('[data-estado]');
      var conteo = sec.querySelector('[data-conteo]');
      var zona = sec.querySelector('[data-activos]');
      if (!zonaEstado || !conteo || !zona) return;

      var hayAlgo = activos() > 0 || busqueda !== '';
      zonaEstado.hidden = !hayAlgo;
      conteo.innerHTML = '<b>' + visibles + '</b> de ' + tarjetas.length +
        (tarjetas.length === 1 ? ' producto' : ' productos');

      zona.innerHTML = '';
      grupos.forEach(function (g) {
        estado[g.id].forEach(function (val) {
          var op = g.ops.filter(function (o) { return o.val === val; })[0];
          if (!op) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'aboreo-catalog__chip';
          b.innerHTML = op.lab.replace(/</g, '&lt;') + ' <span>&times;</span>';
          b.setAttribute('aria-label', 'Quitar filtro ' + op.lab);
          b.addEventListener('click', function () {
            estado[g.id] = estado[g.id].filter(function (x) { return x !== val; });
            aplicar();
          });
          zona.appendChild(b);
        });
      });
    }

    /* ---- aplicar todo ---- */
    function aplicar() {
      var visibles = 0;
      tarjetas.forEach(function (c) {
        var ok = pasaTodo(c, null);
        c.el.style.display = ok ? '' : 'none';
        if (ok) visibles++;
      });

      var sinBusqueda = sec.querySelector('[data-aboreo-catalog-no-results]');
      var sinFiltros = sec.querySelector('[data-sin-resultados]');
      var soloBusqueda = busqueda !== '' && activos() === 0;
      if (sinBusqueda) sinBusqueda.hidden = !(soloBusqueda && visibles === 0);
      if (sinFiltros) sinFiltros.hidden = !(activos() > 0 && visibles === 0);

      var btn = sec.querySelector('[data-filtros-abrir]');
      if (btn) {
        btn.classList.toggle('tiene-filtros', activos() > 0);
        var badge = btn.querySelector('[data-filtros-conteo-boton]');
        if (badge) badge.textContent = activos() ? activos() : '';
      }
      var ver = sec.querySelector('[data-filtros-ver]');
      if (ver) ver.textContent = 'Ver ' + visibles + ' producto' + (visibles === 1 ? '' : 's');

      /* Si hay más de una página, filtrar solo vería la página actual: se avisa
         ocultando el paginador mientras haya filtros puestos. */
      var pag = sec.querySelector('[data-paginacion]');
      if (pag) pag.hidden = activos() > 0 || busqueda !== '';

      pintarPanel();
      pintarChips(visibles);
      escribirUrl();
    }

    /* ---- buscador ---- */
    var input = sec.querySelector('[data-aboreo-catalog-search]');
    if (input) {
      input.addEventListener('input', function () {
        busqueda = input.value.trim().toLowerCase();
        aplicar();
      });
    }

    /* ---- cajón en celular ---- */
    var velo = sec.querySelector('[data-filtros-velo]');
    function abrirPanel(v) {
      panel.classList.toggle('abierto', v);
      if (velo) velo.classList.toggle('abierto', v);
      document.body.classList.toggle('aboreo-filtros-abiertos', v);
    }
    var btnAbrir = sec.querySelector('[data-filtros-abrir]');
    if (btnAbrir) { btnAbrir.hidden = false; btnAbrir.addEventListener('click', function () { abrirPanel(true); }); }
    var btnCerrar = sec.querySelector('[data-filtros-cerrar]');
    if (btnCerrar) btnCerrar.addEventListener('click', function () { abrirPanel(false); });
    if (velo) velo.addEventListener('click', function () { abrirPanel(false); });
    var btnVer = sec.querySelector('[data-filtros-ver]');
    if (btnVer) btnVer.addEventListener('click', function () { abrirPanel(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') abrirPanel(false);
    });
    var limpiarVacio = sec.querySelector('[data-limpiar-vacio]');
    if (limpiarVacio) limpiarVacio.addEventListener('click', limpiarTodo);

    /* ---- arranque ---- */
    leerUrl();
    if (input && busqueda) input.value = busqueda;
    panel.hidden = false;
    aplicar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-aboreo-Corregido"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-aboreo-product]').forEach(function(root){
    var variantsEl = root.parentElement.querySelector('[data-aboreo-variants]') || document.querySelector('[data-aboreo-variants]');
    var variants = [];
    try{ variants = JSON.parse(variantsEl.textContent); }catch(e){}

    var optionValues = {};
    root.querySelectorAll('[data-aboreo-option-value].is-selected').forEach(function(btn){
      optionValues[btn.dataset.optionIndex] = btn.dataset.value;
    });

    function findVariant(){
      return variants.find(function(v){
        var opts = [v.option1, v.option2, v.option3];
        return Object.keys(optionValues).every(function(idx){ return opts[idx] === optionValues[idx]; });
      });
    }

    // Switches the main image + active thumbnail to whatever image is assigned to this variant
    // in Shopify (variant.image_id / variant.featured_image). Falls back to leaving the current
    // image untouched if the variant has no image of its own assigned.
    function updateImageForVariant(variant){
      if(!variant) return;
      var mainImg = root.querySelector('[data-aboreo-main-image]');
      var thumbs = root.querySelectorAll('[data-aboreo-thumb]');

      if(variant.featured_image && variant.featured_image.src){
        if(mainImg) mainImg.src = variant.featured_image.src;
      }

      if(variant.image_id){
        thumbs.forEach(function(thumb){
          var isMatch = String(thumb.dataset.mediaId) === String(variant.image_id);
          thumb.classList.toggle('is-active', isMatch);
          if(isMatch && mainImg && thumb.dataset.full) mainImg.src = thumb.dataset.full;
        });
      }
      if(typeof resetImageZoom === 'function') resetImageZoom();
    }

    function updateUI(){
      var variant = findVariant();
      if(!variant) return;
      // aboreoFormatMoney espera el precio ya en pesos (unidad mayor), NO en centavos.
      // Antes se multiplicaba por 100 pensando que la función esperaba centavos, y eso hacía
      // que el precio se mostrara 100 veces más alto al cambiar de variante (ej. $35.000 -> $3.500.000).
      var price = window.aboreoFormatMoney ? window.aboreoFormatMoney(parseFloat(variant.price)) : (variant.price + ' ' + ((window.Shopify && Shopify.currency && Shopify.currency.active) || ''));
      var priceEl = root.querySelector('[data-aboreo-price]');
      if(priceEl) priceEl.textContent = price;
      var idInput = root.querySelector('[data-aboreo-variant-id]');
      if(idInput) idInput.value = variant.id;
      var sku = root.querySelector('[data-aboreo-sku]');
      if(sku) sku.textContent = variant.sku || '';
      var buyBtn = root.querySelector('[data-aboreo-buy-button]');
      var buyLabel = root.querySelector('[data-aboreo-buy-label]');
      if(buyBtn){
        buyBtn.disabled = !variant.available;
        if(buyLabel) buyLabel.textContent = variant.available ? buyLabel.dataset.label || buyLabel.textContent.replace('AGOTADO','') : 'AGOTADO';
      }
      updateImageForVariant(variant);
    }

    root.querySelectorAll('[data-aboreo-option-value]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var idx = btn.dataset.optionIndex;
        root.querySelectorAll('[data-aboreo-option-value][data-option-index="'+idx+'"]').forEach(function(b){ b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        optionValues[idx] = btn.dataset.value;
        var label = btn.closest('[data-option-index]').querySelector('[data-option-value-label]');
        if(label) label.textContent = btn.dataset.value;
        updateUI();
      });
    });

    root.querySelectorAll('[data-aboreo-thumb]').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        root.querySelectorAll('[data-aboreo-thumb]').forEach(function(t){ t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var img = root.querySelector('[data-aboreo-main-image]');
        if(img) img.src = thumb.dataset.full;
        if(typeof resetImageZoom === 'function') resetImageZoom();
      });
    });

    var qtyInput = root.querySelector('[data-aboreo-qty-input]');
    var minus = root.querySelector('[data-aboreo-qty-minus]');
    var plus = root.querySelector('[data-aboreo-qty-plus]');
    if(minus) minus.addEventListener('click', function(){ qtyInput.value = Math.max(1, (parseInt(qtyInput.value)||1) - 1); });
    if(plus) plus.addEventListener('click', function(){ qtyInput.value = (parseInt(qtyInput.value)||1) + 1; });

    var form = root.querySelector('[data-aboreo-form]');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var buyBtn = root.querySelector('[data-aboreo-buy-button]');
        var buyLabel = root.querySelector('[data-aboreo-buy-label]');
        if(!buyBtn || buyBtn.disabled || buyBtn.classList.contains('is-loading')) return;
        var originalLabel = buyLabel ? buyLabel.textContent : '';
        buyBtn.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: form.querySelector('[data-aboreo-variant-id]').value,
              quantity: parseInt(qtyInput ? qtyInput.value : 1) || 1
            }]
          })
        })
          .then(function(res){ if(!res.ok){ return res.json().then(function(err){ throw err; }); } return fetch('/cart.js'); })
          .then(function(res){ return res.json(); })
          .then(function(cart){
            var cartLink = document.querySelector('.aboreo-header__cart');
            if(cartLink){
              var count = cartLink.querySelector('.aboreo-header__cart-count');
              if(!count){
                count = document.createElement('span');
                count.className = 'aboreo-header__cart-count';
                cartLink.appendChild(count);
              }
              count.textContent = cart.item_count;
            }
            var bottomNavIconWrap = document.querySelector('.aboreo-bottomnav__icon-wrap');
            if(bottomNavIconWrap){
              var badge = bottomNavIconWrap.querySelector('.aboreo-bottomnav__badge');
              if(!badge){
                badge = document.createElement('span');
                badge.className = 'aboreo-bottomnav__badge';
                bottomNavIconWrap.appendChild(badge);
              }
              badge.textContent = cart.item_count;
            }
            buyBtn.classList.remove('is-loading');
            buyBtn.classList.add('is-added');
            if(buyLabel) buyLabel.textContent = '¡AGREGADO!';
            setTimeout(function(){
              buyBtn.classList.remove('is-added');
              if(buyLabel) buyLabel.textContent = originalLabel;
            }, 1800);
          })
          .catch(function(){
            buyBtn.classList.remove('is-loading');
            if(buyLabel) buyLabel.textContent = originalLabel;
          });
      });
    }
    var buyNowBtn = root.querySelector('[data-aboreo-buy-now-button]');
    if(buyNowBtn){
      buyNowBtn.addEventListener('click', function(){
        if(buyNowBtn.disabled || buyNowBtn.classList.contains('is-loading')) return;
        buyNowBtn.classList.add('is-loading');

        var variantIdInput = root.querySelector('[data-aboreo-variant-id]');
        var qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantIdInput.value, quantity: qty }]
          })
        })
          .then(function(res){ if(!res.ok){ return res.json().then(function(err){ throw err; }); } return res.json(); })
          .then(function(){ window.location.href = '/checkout'; })
          .catch(function(){ buyNowBtn.classList.remove('is-loading'); });
      });
    }

    // --- Zoom: en computador (mouse fino) la imagen se amplía siguiendo el cursor.
    // En celular/tablet (sin mouse fino) el zoom pasa directo sobre la misma foto:
    // doble toque para acercar/alejar, pellizcar con dos dedos y arrastrar para moverse. Sin ventana emergente.
    var zoomBox = root.querySelector('[data-aboreo-zoom]');
    var mainImgEl = root.querySelector('[data-aboreo-main-image]');
    var hasFinePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if(zoomBox && mainImgEl && hasFinePointer){
      zoomBox.addEventListener('mousemove', function(e){
        var rect = zoomBox.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImgEl.style.transformOrigin = x + '% ' + y + '%';
        mainImgEl.style.transform = 'scale(2)';
      });
      zoomBox.addEventListener('mouseleave', function(){
        mainImgEl.style.transform = '';
        mainImgEl.style.transformOrigin = '';
      });
    }

    var tScale = 1, tX = 0, tY = 0, tStartDist = 0, tStartScale = 1, tLastTap = 0;
    var tDragging = false, tDragStartX = 0, tDragStartY = 0, tOriginX = 0, tOriginY = 0;

    function touchDistance(touches){
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function applyImageZoom(){
      if(!mainImgEl) return;
      mainImgEl.style.transformOrigin = 'center center';
      mainImgEl.style.transform = 'translate(' + tX + 'px,' + tY + 'px) scale(' + tScale + ')';
    }

    function resetImageZoom(){
      tScale = 1; tX = 0; tY = 0;
      if(mainImgEl){ mainImgEl.style.transform = ''; mainImgEl.style.transformOrigin = ''; }
      if(zoomBox) zoomBox.classList.remove('is-touch-zooming');
    }

    if(zoomBox && mainImgEl && !hasFinePointer){
      zoomBox.addEventListener('touchstart', function(e){
        if(e.touches.length === 2){
          zoomBox.classList.add('is-touch-zooming');
          tStartDist = touchDistance(e.touches);
          tStartScale = tScale;
        } else if(e.touches.length === 1){
          var now = Date.now();
          if(now - tLastTap < 300){
            zoomBox.classList.add('is-touch-zooming');
            if(tScale > 1){ resetImageZoom(); } else { tScale = 2.2; applyImageZoom(); }
          }
          tLastTap = now;
          if(tScale > 1){
            tDragging = true;
            tDragStartX = e.touches[0].clientX; tDragStartY = e.touches[0].clientY;
            tOriginX = tX; tOriginY = tY;
          }
        }
      }, { passive: true });

      zoomBox.addEventListener('touchmove', function(e){
        if(e.touches.length === 2){
          e.preventDefault();
          var dist = touchDistance(e.touches);
          var ratio = dist / (tStartDist || dist);
          tScale = Math.min(4, Math.max(1, tStartScale * ratio));
          applyImageZoom();
        } else if(e.touches.length === 1 && tDragging && tScale > 1){
          e.preventDefault();
          tX = tOriginX + (e.touches[0].clientX - tDragStartX);
          tY = tOriginY + (e.touches[0].clientY - tDragStartY);
          applyImageZoom();
        }
      }, { passive: false });

      zoomBox.addEventListener('touchend', function(e){
        if(e.touches.length === 0){
          tDragging = false;
          zoomBox.classList.remove('is-touch-zooming');
          if(tScale <= 1){ tX = 0; tY = 0; applyImageZoom(); }
        }
      });
    }

    var zoomOpenBtn = root.querySelector('[data-aboreo-zoom-open]');
    if(zoomOpenBtn){
      zoomOpenBtn.addEventListener('click', function(){
        if(hasFinePointer) return;
        if(tScale > 1){ resetImageZoom(); } else { tScale = 2.2; applyImageZoom(); zoomBox.classList.add('is-touch-zooming'); }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
